import { computed } from 'vue'
import { useStore } from 'vuex'
import { isEqual } from 'lodash'
import { BLUR_REPORT, REPORT_EARNING_TYPE } from '../../constant/index'
import DateSelectDropdown from '../date-select-dropdown'
import { DATE_RANGE_OPTIONS } from 'src/utils/constants/common'

const graphSvg = '../../../../../../assets/images/Graph.svg'

export default {
  components: {
    DateSelectDropdown
  },
  setup() {
    const store = useStore()

    const isEarningReport = computed(() => isEqual(store.getters['dashboard/getReportType'], 'earnings'))
    const ufda2Status = computed(() => store.getters['dashboard/getUfda2Status'])
    const totalLabel = computed(() => isEarningReport.value ? 'total_earnings' : 'total_orders' )
    const totalValue = computed(() => isEarningReport.value ? BLUR_REPORT.earning.total : BLUR_REPORT.order.total)
    const highest = computed(() => isEarningReport.value ? 'highest_sales' : 'promotion_orders')
    const topCount = computed(() => isEarningReport.value ? 'top_font' : 'top_license_sold')
    const topLicenseCountry = computed(() => isEarningReport.value ? 'top_license_type' : 'top_order_country')
    const viewReportBtnClass = computed(() => `btn-bg--${ufda2Status.value ? 'blue' : 'gray'}`)

    const changeEarningType = type => {
      store.commit('dashboard/setReportType', type)
      if (isEqual(REPORT_EARNING_TYPE, type)) {
        store.dispatch('dashboard/modifiedEarningGraphData')
      } else {
        store.dispatch('dashboard/modifiedOrderGraphData')
      }
    }

    return {
      isEarningReport,
      changeEarningType,
      ufda2Status,
      totalLabel,
      totalValue,
      highest,
      topCount,
      topLicenseCountry,
      blurReport: BLUR_REPORT,
      graphSvg,
      viewReportBtnClass,
      DATE_RANGE_OPTIONS
    }
  }
}
